"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReportsStorage = void 0;
const base32_encode_1 = __importDefault(require("base32-encode"));
class ReportsStorage {
    static async fetchMACAddress(serialNumber) {
        const response = await fetch("https://functions.egzotech.com/fetch_reports/");
        if (!response.ok) {
            throw new Error("Cannot fetch MAC address");
        }
        const reports = await response.json();
        for (let i = 0; i < reports.length; i++) {
            const report = reports[i];
            const mac = report.stella.mac.split(":").map(v => parseInt(v, 16));
            mac.splice(1, 1);
            const macUint8 = new Uint8Array(mac);
            const calculatedSerialNumber = base32_encode_1.default(macUint8, "RFC4648");
            if (serialNumber === calculatedSerialNumber) {
                return report.stella.mac;
            }
        }
        throw new Error("MAC address cannot be fetched");
    }
}
exports.ReportsStorage = ReportsStorage;
//# sourceMappingURL=ReportsStorage.js.map